import { categoryGroups } from '@/mocks/homeData';

export default function TopicCategories() {
  const jump = (id: string) => {
    const el = document.getElementById(id);
    if (el) window.scrollTo({ top: el.offsetTop - 72, behavior: 'smooth' });
  };

  return (
    <section id="topics" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-10 md:mb-14">
          <div className="max-w-2xl">
            <span className="text-xs font-medium tracking-widest text-primary-600 uppercase">
              主题分类
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mt-3 mb-4">
              按主题进入，找参照更直接
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              每个主题下都维护着自己的对比线索与案例集合。想找结构相近的事件时，从主题进入通常比按关键词搜索更快。
            </p>
          </div>
          <button
            type="button"
            onClick={() => jump('cases')}
            className="self-start lg:self-auto px-5 py-2.5 rounded-md border border-background-300 text-sm font-medium text-foreground-800 hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            浏览全部案例
          </button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categoryGroups.map((group) => (
            <button
              key={group.name}
              type="button"
              onClick={() => jump('cases')}
              className="text-left bg-background-100 border border-background-200 rounded-lg p-5 md:p-6 hover:border-secondary-300 transition-colors cursor-pointer"
            >
              <div className="flex items-center justify-between mb-4">
                <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                  <i className={`${group.icon} text-xl`}></i>
                </span>
                <span className="font-heading text-lg font-bold text-foreground-950">
                  {group.count}
                  <span className="text-xs font-normal text-foreground-500 ml-1">例</span>
                </span>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-950 mb-1.5">
                {group.name}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{group.desc}</p>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}